module.exports = __webpack_public_path__ + "static/media/arrowBackwards.89c3f11c.svg";